// Generated with util/create-component.js
import React from "react";
import {
  StyledTitleBar,
  StyledTitlePlain,
  StyledTitleDivider,
  StyledTitleDividerLineOnly,
  StyledTitleBar2,
} from "./Title.styles";

import { TitleProps } from "./Title.types";

const Title: React.FC<TitleProps> = ({
  bartype,
  text,
  theme,
  size,
  variant,
  children,
  isLive,
  allowTextWrap
}) => {
  switch (bartype) {
    default:
    case "plain":
      return (
        <StyledTitlePlain
          theme={theme}
          variant={variant}
          className={`${size} title-plain`}
          data-testid="Title"
        >
          {!!text && (<span>{text}</span>)}
          {!!children && children}
        </StyledTitlePlain>
      );

    case "divider":
      return !!text ? (
        <StyledTitleDivider
          className={`${size} title-divider ${theme}`}
          theme={theme}
          variant={variant}
          data-testid="Title"
          allowTextWrap={allowTextWrap}
        >
          {!!text && (<span>{text}</span>)}
          {!!children && children}
        </StyledTitleDivider>
      ) : (
        <StyledTitleDividerLineOnly
          className="title-divider"
          theme={theme}
          data-testid="Title"
        />
      );

    case "bar":
      return (
        <StyledTitleBar
          className={`${size} title-bar1 ${theme}`}
          theme={theme}
          variant={variant}
          data-testid="Title"
        >
          {!!text && (<span>{text}</span>)}
          {!!children && children}
        </StyledTitleBar>
      );

    case "summary":
      return (
        <StyledTitleBar2
          className={`${size} title-bar2 ${theme}`}
          theme={theme}
          variant={variant}
          data-testid="Title"
          isLive={isLive}
        >
          {!!text && (<span>{text}</span>)}
          {!!children && children}
        </StyledTitleBar2>
      );
  }
};

export default Title;
